<template>
    <page>
    </page>
</template>

<script>
    export default {
        middleware: ['check-open-auth'],

        mounted() {
            this.$router.push({name:'login'})
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/welcome.vue